import { createContext, PropsWithChildren, useContext, useId, useMemo } from 'react';
import { observable, runInAction } from 'mobx';
import { useMount, useUnmount } from '@cutwise/react-utils';

export type Stores = object;

export const StoresContext = createContext<Stores>({});

export const mountedStores = observable.map<string, Stores>({}, { deep: false });

interface StoresProviderProps {
  stores: Stores;
}

export function StoresProvider(props: PropsWithChildren<StoresProviderProps>) {
  const { stores, children } = props;
  const parentStores = useContext(StoresContext);
  const id = useId();

  const value = useMemo(() => ({ ...parentStores, ...stores }), [parentStores, stores]);

  useMount(() => runInAction(() => mountedStores.set(id, stores)));
  useUnmount(() => runInAction(() => mountedStores.delete(id)));

  return <StoresContext.Provider value={value}>{children}</StoresContext.Provider>;
}
